/**
 * CKEditor Loader
 * Loads and configures CKEditor from CDN
 */

declare global {
    interface Window {
        CKEDITOR: any;
        CKEDITOR_BASEPATH: string;
    }
}

const CKEDITOR_VERSION = '4.22.1';
const CKEDITOR_CDN_URL = `https://cdn.ckeditor.com/${CKEDITOR_VERSION}/standard-all/ckeditor.js`;

/**
 * Load CKEditor from CDN and configure it
 */
export function loadCKEditor(): Promise<any> {
    return new Promise((resolve, reject) => {
        // Check if CKEditor is already loaded
        if (window.CKEDITOR) {
            configureCKEditor();
            resolve(window.CKEDITOR);
            return;
        }

        // Set base path before loading
        window.CKEDITOR_BASEPATH = `https://cdn.ckeditor.com/${CKEDITOR_VERSION}/standard-all/`;

        // Create script element
        const script = document.createElement('script');
        script.src = CKEDITOR_CDN_URL;
        script.async = true;

        script.onload = () => {
            if (window.CKEDITOR) {
                configureCKEditor();
                resolve(window.CKEDITOR);
            } else {
                reject(new Error('CKEditor failed to load'));
            }
        };

        script.onerror = () => {
            reject(new Error('Failed to load CKEditor script'));
        };

        // Append to head
        document.head.appendChild(script);
    });
}

/**
 * Configure CKEditor after loading
 */
function configureCKEditor(): void {
    if (!window.CKEDITOR) {
        return;
    }

    // Set language
    window.CKEDITOR.config.language = 'en';

    // Suppress the security warning about outdated version
    window.CKEDITOR.config.versionCheck = false;
}

// Auto-load CKEditor when this module is imported
loadCKEditor().catch((error) => {
    console.error('Failed to load CKEditor:', error);
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/ckeditor-loader.ts